import AppHeader from '../AppHeader'

//
// 書類更新 提出一覧（店舗管理者・事務員: 自店 / システム管理者: 全店）
//
export default {
  name: 'document-renewal-list',
  created () {
    if (!this.canReview) {
      this.$router.push({ path: '/' })
      return
    }
    this.search()
  },
  data () {
    return {
      status: 'submitted',
      searchCallbackFlag: false
    }
  },
  computed: {
    renewals () {
      return this.$store.getters.documentRenewals
    },
    forbidden () {
      return this.$store.getters.documentRenewalForbidden
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isShopMaster () {
      return this.$store.getters.shopMaster
    },
    isClerk () {
      return this.$store.getters.clerk
    },
    canReview () {
      return this.isShopMaster || this.isClerk || this.isSystemManagement
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      var data = {}
      if (this.status) {
        data['status'] = this.status
      }
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      this.$store.dispatch('GET_DOCUMENT_RENEWALS', {data: data, callback: callback})
    },
    statusClass: function (status) {
      if (status === 'submitted') return 'label-warning'
      if (status === 'confirmed') return 'label-success'
      if (status === 'rejected') return 'label-danger'
      return 'label-default'
    },
    goDetail: function (id) {
      window.sessionStorage.setItem('BackPage', '/document_renewals')
      this.$router.push({ path: '/document_renewals/' + id })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/document-renewal-list.js